import React from 'react';

import styles from './Notification.scss';

const Notification = ({ message, onClose }) =>
    message && (
        <div className={styles.notification}>
            <div className={styles.decoration}>
                <i className="bol-icon-icon_checkmark" />
            </div>
            <div onClick={onClose} className={styles.close}>
                <i className="bol-icon-icon_cross" />
            </div>
            <p className={styles.message}>{message}</p>
        </div>
    );

export default Notification;



// WEBPACK FOOTER //
// ./src/components/Notification.js